import React from "react";
import { Add } from "@mui/icons-material";

import { ActionButton } from "../button/ActionButton";

import { ManageGroupDialog } from "./ManageGroupDialog";
import { GroupNameDialog, GroupNameDialogProps } from "./GroupNameDialog";
import { GroupDto2 } from "@growth-machine-llc/stridist-api-client";
import { HeaderButton } from "../button/HeaderButton";

export interface CreateGroupActionProps {
  disabled?: boolean;
  className?: string;
}
export function CreateGroupAction(props: CreateGroupActionProps) {
  const { disabled = false, className } = props;
  const [groupNameDialogOpen, setGroupNameDialogOpen] = React.useState(false);
  const [manageGroupDialogOpen, setManageGroupDialogOpen] =
    React.useState(false);
  const [group, setGroup] = React.useState<GroupDto2>();

  const handleCreateGroupClick = React.useCallback(() => {
    setGroupNameDialogOpen(true);
  }, []);

  const handleCloseGroupDialog = React.useCallback(() => {
    setGroupNameDialogOpen(false);
  }, []);

  const handleCloseManageGroupDialog = React.useCallback(() => {
    setManageGroupDialogOpen(false);
  }, []);

  const handleCreated: GroupNameDialogProps["onCreated"] = React.useCallback(
    (group) => {
      setGroup(group);
      setManageGroupDialogOpen(true);
    },
    [],
  );
  return (
    <>
      <HeaderButton
        startIcon={<Add />}
        onClick={handleCreateGroupClick}
        disabled={disabled}
        useThemePalette={false}
        className={className}
      >
        Create group
      </HeaderButton>

      {groupNameDialogOpen && (
        <GroupNameDialog
          open={true}
          onClose={handleCloseGroupDialog}
          onCreated={handleCreated}
        />
      )}

      {group && manageGroupDialogOpen && (
        <ManageGroupDialog
          open={true}
          onClose={handleCloseManageGroupDialog}
          group={group}
        />
      )}
    </>
  );
}
